/**
 * Decode an encoded polyline (Google/OSRM precision-1e5 algorithm) into [lat, lng] pairs.
 * Shared by the Leaflet route map (load-hub) and the Google route map (box-truck) so the toll-route
 * geometry from the HERE-backed toll endpoint is drawn identically on either engine.
 */
export function decodePolyline(encoded: string): Array<[number, number]> {
    const points: Array<[number, number]> = []
    if (!encoded || typeof encoded !== 'string') return points

    let index = 0
    let lat = 0
    let lng = 0

    while (index < encoded.length) {
        let shift = 0
        let result = 0
        let byte: number
        do {
            byte = encoded.charCodeAt(index++) - 63
            result |= (byte & 0x1f) << shift
            shift += 5
        } while (byte >= 0x20)
        lat += result & 1 ? ~(result >> 1) : result >> 1

        shift = 0
        result = 0
        do {
            byte = encoded.charCodeAt(index++) - 63
            result |= (byte & 0x1f) << shift
            shift += 5
        } while (byte >= 0x20)
        lng += result & 1 ? ~(result >> 1) : result >> 1

        points.push([lat / 1e5, lng / 1e5])
    }
    return points
}
